<template>
    <div class="main d-flex flex-column justify-content-center bg-white">
        <div class="bg-g-transparent-light">
            <section id="brn-membership">
                <BorderDecoration primary="var(--color-secondary)" secondary="var(--color-gray-light)" style="left: -5%" />
                <div class="container">
                    <div class="title text-center">
                        <ChalkDecoration class="m-auto">
                            <h3 v-html="content['membership-hero'].data.title"></h3>
                        </ChalkDecoration>
                        <p v-html="content['membership-hero'].data.text"></p>
                    </div>
                    <div class="row offers-grid">
                        <div v-for="(product, index) in 6" :key="index" class="col-md-12 col-lg-6 col-xl-4 p-0">
                            <MembershipCard
                                :id="index"
                                :title="'Membership #' + (index + 1)"
                                v-on:buy="$refs['quick-buy-modal'].open()"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <BuyMembershipModal ref="quick-buy-modal"/>
    </div>
</template>

<script>
import ChalkDecoration from "../components/elements/ChalkDecoration";
import OwlCarousel from "vue-owl-carousel";
import BorderDecoration from "../components/elements/BorderDecoration";
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import MembershipCard from "../components/cards/MembershipCard";
import BuyMembershipModal from "../components/elements/BuyMembershipModal";
export default {
    name: "Membership",
    components: {BuyMembershipModal, MembershipCard, BorderDecoration, OwlCarousel, ChalkDecoration},
    mixins: [PageLayoutContentMixin]
}
</script>

<style lang="scss" scoped>
.bg-transparent-to-white {
    background: linear-gradient(180deg, #f8f8ff, rgb(255, 255, 255));
}

</style>
